export class ProjectDeviceAssignement {

    public device: number;
    public name: string;
    public dyndns: string;
}
